import React from 'react';
import { FlatList } from "react-native"
import type { PlayerBalanceProps, PlayerSquareProps, SquareOfferProps, SquareProps } from "../../types"
import BidToggle from "./BidToggle"
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type OfferFormProps = {
    player_id?:string,
    player_balance?:PlayerBalanceProps,
    market_type:string,
    home_abbr?:string,
    away_abbr?:string,
    width:number
    submit_ready: { is_loading:boolean, is_ready:Boolean }
    onSubmitOffer: () => void,
    onClearOffers: () => void,
    onOfferAmountChange: (offer:SquareOfferProps, player_square:PlayerSquareProps, direction: 'increase'|'decrease') => void,
    onRequestAuthenticate: () => void,
    draft_square_offers:SquareOfferProps[],
    player_squares:PlayerSquareProps[],
    squares:SquareProps[]
}

const OfferForm = ({ player_id, player_balance, market_type, squares, submit_ready, home_abbr, away_abbr, player_squares, draft_square_offers, onRequestAuthenticate, onOfferAmountChange, onClearOffers, onSubmitOffer }:OfferFormProps) => {
    const Colors = useColors();
    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'
    const total_offer_amount = draft_square_offers.reduce((a,b) => a + b.amount, 0)

    let can_submit = player_balance && total_offer_amount < player_balance.balance ? true : false
    
    
    const renderDraftOffers = (data: { item:SquareOfferProps, index:number }) => {
        let ps = player_squares.find(psQ => psQ.sq_player_square_id == data.item.sq_player_square_id)
        if(!ps){ return (<></>) }
        let square = squares.find(s => s.sq_square_id == ps?.sq_square_id)
        if(!square){ return ( <></> ) }
        return (
            <View transparent style={{flex:1, flexDirection:'row', alignItems:'center', marginBottom:8}}>
                <View transparent style={{flex:1}}>
                    <Text theme='description'>SQUARE: {home_abbr}: {square.square_score_x}, {away_abbr}: {square.square_score_y}</Text>
                    <Text theme='description'>Purchased Price: {cl}{ps.purchase_price.toFixed(2)}</Text>
                </View>
                <View transparent>
                    <BidToggle sq_square_id={square.sq_square_id} amount={data.item.amount} cl={cl}  onAmountChange={(dir) => onOfferAmountChange(data.item, ps, dir)}/>
                </View>
            </View>
        )
    }

    if(!draft_square_offers[0]){ return <></> }

    return (
        <View float>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <View transparent style={{ flex:1 }}>
                    <Text theme="h1">SET YOUR {draft_square_offers[0].buy_sell_ind==='buy'?'OFFER AMOUNTS':'SELL PRICE'}</Text>
                    {draft_square_offers[0].buy_sell_ind === 'buy' ?
                    <Text style={{ marginTop:3 }} theme="description">How much are you willing to offer the current square owner</Text>
                    :
                    <Text style={{ marginTop:3 }} theme="description">How much are you willing to sell the selected square for?</Text>
                    }
                </View>
                <View float style={{ height:24, width:24, borderRadius:100, justifyContent:'center', alignItems:'center', marginLeft: 5 }}>
                    <Text size={12} color={Colors.text.h1} textAlign='center'>{draft_square_offers.length}</Text>
                </View>
            </View>

            <View transparent type='body' style={{ padding:10 }}>
                <FlatList data={draft_square_offers.sort((a,b) => parseInt(a.sq_player_square_id) - parseInt(b.sq_player_square_id))} renderItem={renderDraftOffers} keyExtractor={(item) => `o-${item.sq_player_square_id}`}/>
                <View transparent type='row' style={{ marginTop:5 }}>
                    <Text style={{ flex:1 }} theme='h2'>Total</Text>
                    <Text theme='h1'>{cl}{total_offer_amount.toFixed(2)}</Text>
                </View>
            </View>
            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>                
                <Button 
                    type='error'
                    title='CLEAR'
                    style={{ flex:1 }} onPress={() => onClearOffers()}>
                </Button>
                {player_id ?
                <Button 
                    disabled={!can_submit || submit_ready.is_loading}
                    loading={submit_ready.is_loading}
                    style={{ flex:2, opacity:submit_ready.is_loading || !can_submit ? 0.5:1, marginLeft:5, backgroundColor:submit_ready.is_ready?Colors.text.success:Colors.text.action }} 
                    type='success'
                    title={submit_ready.is_ready?'SUBMIT OFFER':'REVIEW OFFER'}
                    onPress={() => onSubmitOffer()}
                />
                :
                <Button 
                    style={{ flex:2, marginLeft:5 }}
                    type='success'
                    onPress={() => onRequestAuthenticate()}>
                    <Text size={14} weight='semibold' textAlign='center' color={Colors.text.white}>Sign Up</Text>
                </Button>
                }
            </View>
        </View>
    )
}

export default OfferForm